import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let QuizViewerLayout = class QuizViewerLayout extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "centerContent", void 0);
  }
  timerExists() {
    return this.$slots && this.$slots.timer !== undefined;
  }
  footerExists() {
    return this.$slots && this.$slots.footer !== undefined;
  }
};
__decorate([Prop({
  default: false
})], QuizViewerLayout.prototype, "centerContent", void 0);
QuizViewerLayout = __decorate([Component], QuizViewerLayout);
export default QuizViewerLayout;